module.exports = __webpack_public_path__ + "media/images/ir/common/logo-bl-490702fa4f33acd7df240e572f869db1.svg";